import VueRouter, { RouteConfig } from 'vue-router'

const Home = () => import('../views/Home.vue')
const Layout = () => import('../views/Layout.vue')
const ClazzList = () => import('../views/ClazzList.vue')
const PersonalCenter = () => import('../views/PersonalCenter.vue')
const IntelligentHardwardIndex = () => import('../views/jumprope-intelligent/Index.vue')
// const AiChat = () => import('../views/ai-chat/Index.vue')

export const homeRoute: RouteConfig = {
  path: '/home',
  name: 'home',
  component: Home,
}

export const clazzListRoute: RouteConfig = {
  path: '/clazz-list',
  name: 'clazz_list',
  component: ClazzList,
}

export const personalCenterRoute: RouteConfig = {
  path: '/personal-center',
  name: 'personal_center',
  component: PersonalCenter,
}

export const intelligentIndexRoute: RouteConfig = {
  path: '/jumprope-intelligent',
  name: 'jumprope_intelligent',
  component: IntelligentHardwardIndex,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '智能跳绳',
  },
}

// export const aiChatRoute: RouteConfig = {
//   path: '/ai-chat',
//   name: 'ai_chat',
//   component: AiChat,
//   meta: {
//     title: 'AI聊天',
//   },
// }

export const layoutRoute: RouteConfig = {
  path: '/',
  name: 'layout',
  component: Layout,
  redirect: homeRoute.path,
  children: [homeRoute, clazzListRoute, personalCenterRoute, intelligentIndexRoute],
}

export default layoutRoute

export function navigateToHome(router: VueRouter) {
  router.push({ name: homeRoute.name })
}

export function redirectToHome(router: VueRouter) {
  router.replace({ name: homeRoute.name })
}
